import { render, staticRenderFns } from "./publicHead.vue?vue&type=template&id=b42869d2&scoped=true"
import script from "./publicHead.vue?vue&type=script&lang=js"
export * from "./publicHead.vue?vue&type=script&lang=js"
import style0 from "./publicHead.vue?vue&type=style&index=0&id=b42869d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42869d2",
  null
  
)

export default component.exports